import React from 'react';
import { MultiSelectSuggest, MultiSelectSuggestProps } from 'lib/MultiSelectSuggest';
import { Option } from 'lib/types';
import { isDefined } from './typeguards';

interface ChipInputProps extends MultiSelectSuggestProps {
    value: readonly Option[] | Option | null;
    placeholder?: string;
    onChange: (value: readonly Option[] | Option | null) => void;
    label?: React.ReactNode;
    showNoOptionsMessage?: boolean;
    options?: Option[];
}

export const ChipInput: React.FC<ChipInputProps> = props => {
    const [inputValue, setInputValue] = React.useState('');
    const { onChange, value, isCreatable = true, showNoOptionsMessage } = props;
    const handleInputChange = React.useCallback((newValue: string) => {
        setInputValue(newValue);
    }, []);
    const handleKeyDown = React.useCallback(
        (event: React.KeyboardEvent<HTMLElement>) => {
            if (!inputValue) {
                return;
            }
            switch (event.key) {
                case 'Enter':
                case 'Tab':
                case ',':
                    setInputValue('');
                    if (
                        !isDefined(value) ||
                        (Array.isArray(value) && value.every(item => item.value !== inputValue))
                    ) {
                        const hasComma = inputValue.includes(',');
                        const values = hasComma
                            ? inputValue
                                  .split(',')
                                  .map(item => item.trim())
                                  .filter(item => item !== '')
                            : [inputValue];
                        onChange([...(value ?? []), ...values.map(item => ({ value: item, label: item }))]);
                    }
                    event.preventDefault();
            }
        },
        [inputValue, onChange, value]
    );
    return (
        <MultiSelectSuggest
            isCreatable={isCreatable}
            onInputChange={handleInputChange}
            onKeyDown={handleKeyDown}
            showNoOptionsMessage={showNoOptionsMessage}
            inputValue={inputValue}
            {...props}
        />
    );
};
